import { __extends } from "tslib";
import HttpAgent from './http-agent';
var HandshakeAgent = /** @class */ (function (_super) {
    __extends(HandshakeAgent, _super);
    function HandshakeAgent(_a) {
        var baseURL = _a.baseURL, authorization = _a.authorization;
        var _this = _super.call(this, { baseURL: baseURL }) || this;
        _this.authorization = authorization;
        return _this;
    }
    HandshakeAgent.prototype._getHeaders = function () {
        var headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
        if (this.authorization) {
            headers['Authorization'] = this.authorization;
        }
        return headers;
    };
    HandshakeAgent.prototype._getRelativeUrl = function (urlSuffix) {
        return "/wix-chat-tokens-server/v1/" + urlSuffix + "?isForUnifiedList=true";
    };
    return HandshakeAgent;
}(HttpAgent));
export default HandshakeAgent;
